import * as React from 'react';

import type { TFECacheContextType } from '@helpcenter/forge-ui-utils';
import { fetchTFExtensions } from 'rest/trusted-fetch-extensions';
import batchV2 from 'utils/batch-function-v2';
import batch from '@atlassian/help-center-common-util/batch-function';

const batchedGetExtensions = batch(fetchTFExtensions, 0);
const batchedGetExtensionsV2 = batchV2(fetchTFExtensions, 0);

export const TFECacheContext = React.createContext<TFECacheContextType>({
    getExtensionsByType: batchedGetExtensions,
    getExtensionsByTypeV2: batchedGetExtensionsV2,
});

TFECacheContext.displayName = 'TFECacheContext';
